import { render, staticRenderFns } from "./Letters.vue?vue&type=template&id=bc6c79a4&scoped=true&"
import script from "./Letters.vue?vue&type=script&lang=js&"
export * from "./Letters.vue?vue&type=script&lang=js&"
import style0 from "./Letters.vue?vue&type=style&index=0&id=bc6c79a4&scoped=true&lang=css&"
import style1 from "./Letters.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c79a4",
  null
  
)

export default component.exports